import jwtDecode from 'jwt-decode'
import baseApi from './baseApi'

export const brainApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation({
      query: ({ file, selectedUser, mins, secs, counter, condition, headset, userToken }) => {
        const user = jwtDecode(userToken)
        const body = new FormData()
        body.append('file', file)
        body.append('user_id', selectedUser.id)
        body.append('minutes', mins)
        body.append('seconds', secs)
        body.append('thresshold', counter)
        body.append('condition', condition.label)
        body.append('headset_name', headset)
        body.append('person_type', user.person_type)

        return {
          url: 'brain_scan',
          method: 'POST',
          body,
        }
      },
      invalidatesTags: ['brain_report'],
    }),
    uploadDementiaFile: builder.mutation({
      query: ({ file, file_num }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('file_num', file_num)

        return {
          url: 'upload_dementia',
          method: 'POST',
          body,
        }
      },
    }),
    uploadADHDFile: builder.mutation({
      query: ({ file, selectedUser, mins, secs }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('user_id', selectedUser.id)
        body.append('minutes', mins)
        body.append('seconds', secs)

        return { url: 'adhd_detect', method: 'POST', body }
      },
    }),
    getNeuroReports: builder.query({
      query: ({ userId }) => ({
        url: `get_adhd_report?user_id=${userId}`,
      }),
    }),
    getCredits: builder.query({
      query: () => 'license_status',
      transformResponse: (data) => {
        return data.user_status.usage_limit - data.user_status.limit_used
      },
      providesTags: ['brain_report'],
    }),
    getReports: builder.query({
      query: ({ id, test_area }) => ({
        url: 'report_table_brainscan',
        method: 'POST',
        body: { user_id: id, test_area },
      }),
      transformResponse: (data, meta, arg) => {
        return data.brain_scan_report
      },
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
  }),
})

// auto-generated based on the defined endpoints
export const {
  useGetCreditsQuery,
  useUploadFileMutation,
  useGetReportsQuery,
  useUploadDementiaFileMutation,
  useUploadADHDFileMutation,
  useGetNeuroReportsQuery,
} = brainApi
